import router from '../router'
import store from '../store'
import { getTokenInfo, getUserInfo, getMenu } from '../utils/auth'
// import enc from "@/utils/enc"
import { isLocal } from "@/settings.js"

//白名单
// const whiteList = ['/workorder']

// const getOtherQuery = (query) => {
//   return Object.keys(query).reduce((acc, cur) => {
//     if (cur !== "redirect") {
//       acc[cur] = query[cur];
//     }
//     return acc;
//   }, {});
// }
// const flrPath = () => {
//   // 判断设置的几个目录是否存在
//   const menuList = JSON.stringify(getMenu())
//   if (menuList.indexOf('hospitallist') >= 0 && menuList.indexOf('医院列表') >= 0) {
//     return '/hospital/list'
//   } else {
//     return '/'
//   }
// }

router.beforeEach(async (to, from, next) => {
  // 判断用户是否登录
  // const hasToken = getTokenInfo()
  // if (isLocal) {
  //   next()
  //   return
  // }
  // 中台跳转
  // if (to.path === '/workorder') {
  //   const secret_key = to.query.secret_key
  //   if (secret_key) {
  //     await store.dispatch('user/login', secret_key)
  //   }
  //   next()
  //   return
  // }
  next()
})



// WEBPACK FOOTER //
// ./src/modules/workorder/router/permission.js